import React from "react";
import { Header } from "../components/Header";
import { ProfileView, ModerationView } from "../views";
import { DMView } from "../components/DMView";
import { NotificationsView } from "../components/NotificationsView";
import { NetworkView } from "../components/NetworkView";
import { AdminDashboard } from "../components/AdminDashboard";
import { AccountDangerZone } from "../components/AccountDangerZone";

function ChromePage({ user, onOpenProfile, onGoHome, onOpenMessages, onOpenNotifications, onOpenNetwork, onOpenLegal, onOpenAdmin, unreadDm = 0, notifCount = 0, showSearch = true, children }) {
  return (
    <>
      <Header
        user={user}
        onOpenProfile={onOpenProfile}
        onGoHome={onGoHome}
        onOpenMessages={onOpenMessages}
        onOpenNotifications={onOpenNotifications}
        onOpenNetwork={onOpenNetwork}
        onOpenLegal={onOpenLegal}
        onOpenAdmin={onOpenAdmin}
        unreadDm={unreadDm}
        notifCount={notifCount}
        showSearch={showSearch}
      />
      {children}
    </>
  );
}

export function SecondaryRoute({
  route,
  user,
  onGoHome,
  onOpenProfile,
  onOpenMessages,
  onSetRoute,
  onCloseMessages,
  onLogout,
  onDeleteProfile,
  unreadDm = 0,
  notifCount = 0,
  dmInitialPeerId = null,
  profileIdentityId = null,
  onOpenNetwork,
  onOpenLegal,
  onOpenAdmin,
  onOpenNotification,
}) {
  const openMessages = () => onSetRoute("messages");
  const openNotifications = () => onSetRoute("notifications");
  const commonProps = {
    user,
    onOpenProfile,
    onGoHome,
    onOpenMessages: openMessages,
    onOpenNotifications: openNotifications,
    onOpenNetwork,
    onOpenLegal,
    onOpenAdmin,
    unreadDm,
    notifCount,
  };
  if (route === "profile") {
    return (
      <ChromePage {...commonProps}>
        <ProfileView
          user={user}
          profileIdentityId={profileIdentityId || user?.identityId}
          onBack={onGoHome}
          onOpenModeration={() => onSetRoute("moderation")}
          onOpenMessages={onOpenMessages}
          onOpenNetwork={() => onSetRoute("network")}
              onOpenNotification={onOpenNotification}
          onLogout={onLogout}
        />
        {(profileIdentityId || user?.identityId) === user?.identityId && (
          <AccountDangerZone onDeleteProfile={onDeleteProfile} />
        )}
      </ChromePage>
    );
  }
  if (route === "moderation") {
    return (
      <ChromePage {...commonProps}>
        <ModerationView onBack={() => onSetRoute("profile")} />
      </ChromePage>
    );
  }
  if (route === "admin") {
    return (
      <ChromePage {...commonProps}>
        <AdminDashboard onBack={onGoHome} />
      </ChromePage>
    );
  }
  if (route === "messages") {
    return (
      <ChromePage {...commonProps} showSearch={false}>
        <DMView onBack={onCloseMessages || (() => onSetRoute("home"))} initialPeerId={dmInitialPeerId} />
      </ChromePage>
    );
  }
  if (route === "network") {
    return (
      <ChromePage {...commonProps}>
        <NetworkView onBack={onGoHome} />
      </ChromePage>
    );
  }
  if (route === "notifications") {
    return (
      <ChromePage {...commonProps}>
        <NotificationsView onBack={onGoHome} onOpenNotification={onOpenNotification} />
      </ChromePage>
    );
  }
  return null;
}
